import { render, staticRenderFns } from "./Dating.vue?vue&type=template&id=37b96414&scoped=true"
import script from "./Dating.vue?vue&type=script&lang=js"
export * from "./Dating.vue?vue&type=script&lang=js"
import style0 from "./Dating.vue?vue&type=style&index=0&id=37b96414&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b96414",
  null
  
)

export default component.exports